<template>
  <div class="home__about">
    <home-about-card></home-about-card>
  </div>
</template>

<script>
import HomeAboutCard from "./HomeAboutCard";

export default {
  name: "HomeAbout",
  components: {
    HomeAboutCard
  }
};
</script>

<style scoped lang="scss">
.home__about {
  width: 100%;
  min-height: 922px;
  background: url("../../../assets/img/über-mich.jpg") no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-bottom: 282px;
}

@media (max-width: 767px) {
  .home__about {
    min-height: 1032px;
    padding-bottom: 392px;
  }
}
</style>
